
    import './styles.scoped.css';
    export default {
  "radio-control": "awsui_radio-control_1v1hk_1k1vc_9",
  "outline": "awsui_outline_1v1hk_1k1vc_23",
  "styled-circle-border": "awsui_styled-circle-border_1v1hk_1k1vc_45",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1v1hk_1k1vc_49",
  "styled-circle-readonly": "awsui_styled-circle-readonly_1v1hk_1k1vc_49",
  "styled-circle-fill": "awsui_styled-circle-fill_1v1hk_1k1vc_54",
  "styled-circle-checked": "awsui_styled-circle-checked_1v1hk_1k1vc_70",
  "awsui-radio-select": "awsui_awsui-radio-select_1v1hk_1k1vc_1"
};
  